module.exports = "<script src=\"https://static.opentok.com/v2/js/opentok.js\"></script>\r\n\r\n<ng-container *ngIf=\"session\">\r\n  <app-publisher [session]=\"session\"></app-publisher>\r\n  <app-subscriber *ngFor=\"let stream of streams\" [stream]=\"stream\" [session]=\"session\"></app-subscriber>\r\n  <chat-box [userId]=\"userId\" [userName]=\"userName\" [session]=\"session\"></chat-box>\r\n</ng-container>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/open-tok.component.html
// module id = ../../../../../src/app/shared/components/open-tok/open-tok.component.html
// module chunks = main